import { isServer } from './environment';

export type GeoMenu = {
  countryLinks: CountryLink[];
};

export function createGeoMenu(countryLinks: CountryLink[] | undefined): GeoMenu | undefined {
  if (!countryLinks || countryLinks.length === 0) {
    if (!isServer()) {
      // eslint-disable-next-line no-console
      console.error('No country links provided');
    }

    return undefined;
  }

  return {
    countryLinks,
  };
}
